<app-media-block contentType="workout" [workoutForm]="workoutForm" />

@if (
  createContentService.workoutSource() === 'create' || createContentService.workoutImportedFile()
) {
  <app-training-block contentType="workout" [trainingForm]="TrainingBlockFormGroup" />
}

<app-information-block contentType="workout" [informationForm]="informationBlockFormGroup" />
<app-publication-block
  contentType="workout"
  [publicationForm]="publicationBlockFormGroup"
  [visibilityDisabled]="createContentService.isDeleted()"
/>
